const handingerUrl = import.meta.env.VITE_HANDINGER_BACKEND_URL

type Params = Record<string, string> & { url: string }

// TODO: move to backend and deprecate fika_jwt hack
type FetchParams = {
  params: Params
  handler: "meta" | "llm" | "markdown"
  jwt: string
}
export function fetchFromHandinger({ params, handler, jwt }: FetchParams) {
  const queryString = new URLSearchParams({
    ...params,
    fika_jwt: "true",
  })

  return fetch(`${handingerUrl}/${handler}?${queryString}`, {
    headers: { Authorization: `Bearer ${jwt}` },
  })
}
